import { render, staticRenderFns } from "./AddOrderCommercialInvoice.vue?vue&type=template&id=24735107&scoped=true&"
import script from "./AddOrderCommercialInvoice.vue?vue&type=script&lang=js&"
export * from "./AddOrderCommercialInvoice.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderCommercialInvoice.vue?vue&type=style&index=0&id=24735107&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24735107",
  null
  
)

component.options.__file = "AddOrderCommercialInvoice.vue"
export default component.exports